/* eslint-disable */
import React from 'react';

import FrontshopLink from 'ggApp/shared/containers/FrontshopLink';
import { CartBackToHomeLinkBuilder } from 'ggApp/shared/containers/cartBackToHomeLinkBuilder';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

const BackToHomeLink = () => (
    <CartBackToHomeLinkBuilder
        render={({ backToHomeLink }) => (
            <FrontshopLink to={backToHomeLink} external>
                <Translator tk="CART_BACK_TO_HOME_TEXT" />
            </FrontshopLink>
        )}
    />
);

export default BackToHomeLink;
